module.exports = __webpack_public_path__ + "media/8.2188ea37.wav";